import { render, staticRenderFns } from "./ExpertCategorySelect.vue?vue&type=template&id=2f54795f&scoped=true"
import script from "./ExpertCategorySelect.vue?vue&type=script&lang=js"
export * from "./ExpertCategorySelect.vue?vue&type=script&lang=js"
import style0 from "./ExpertCategorySelect.vue?vue&type=style&index=0&id=2f54795f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_398719d9ba0fb65ce1cea3b2910bec76/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f54795f",
  null
  
)

export default component.exports